import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { BehaviorSubject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { BreakpointObserver } from '@angular/cdk/layout';
import * as moment from 'moment'
declare const swal: any;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-seg-cert-prov',
  templateUrl: './seg-cert-prov.component.html',
  styleUrls: ['./seg-cert-prov.component.css'],
  providers: [UserService]
})
export class SegCertProvComponent implements OnInit {



  displayedColumns: string[] = ['solicitud', 'folio', 'rol', 'fecha', 'rut', 'nombre', 'estado'];

  public fecha = new FormControl('');
  public pagosList = new BehaviorSubject([])
  public pagados
  public pendientes
  public webs
  public totalConsulta
  public busquedaTerminada = false

  screenWidth: number;

  minDate = new Date("2020-01-28");

  maxDate = new Date();

  constructor(private _user: UserService, private spinner: NgxSpinnerService, private breakpointObserver: BreakpointObserver) {

    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      // set screenWidth on screen size change
      this.screenWidth = window.innerWidth;
    }

  }

  ngOnInit() {
  }


  buscar() {
    this.spinner.show()
    var pagos = []
    var dirs = []
    this.pagados = 0
    this.pendientes = 0
    this.webs = 0
    this.totalConsulta = 0
    var dir

    let ffff = moment(this.fecha.value).format("MM/DD/YYYY")
    this._user.get_pagos_cert_prov(ffff).subscribe(response => {
      if (response.status == "error") {

        this.spinner.hide()
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "No se encontraron ingresos para este dia",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      } else {
        for (let i = 0; i < response.carro.length; i++) {
          const el = response.carro[i]
          for (let p = 0; p < el.datos.dire.length; p++) {
            const element = el.datos.dire[p];
            dirs.push(element)
          }

          pagos.push({
            // rol: dirs[0].rol,
            folio: el.folio,
            rut: el.rut,
            fecha: el.fecha_ingreso,
            nombre: el.nombre,
            certificados: dirs,
            solicitud: el.solicitud,
            estado: el.estado,
          })
          dirs = []



        }
        this.totalConsulta = pagos.length
        for (let i = 0; i < pagos.length; i++) {
          if (pagos[i].estado == "Pagado") {
            this.pagados = this.pagados + 1
          }
          if (pagos[i].estado == "Pendiente") {
            this.pendientes = this.pendientes + 1
          }
          if (pagos[i].estado == "WEB") {
            this.webs = this.webs + 1
          }
        }
        this.pagosList.next(pagos)
        this.busquedaTerminada = true
        this.spinner.hide()
      }

    }, error => {
      console.log(error)
    })
  }

}
